import { Component, OnInit } from "@angular/core";
import { MatTabChangeEvent } from "@angular/material/tabs";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "src/app/giz-library/auth/service/auth.service";

@Component({
  selector: "app-tablero-view",
  templateUrl: "./tablero-view.component.html",
  styleUrls: ["./tablero-view.component.css"],
})
export class TableroViewComponent implements OnInit {
  constructor(private router: Router, private route: ActivatedRoute,
    private authService: AuthService) { }

  view!: string;


  ngOnInit(): void {
    document.getElementsByClassName("head")[0].scrollIntoView();
    const _view = this.route.snapshot.paramMap.get("view");

    if (_view) {
      this.view = _view;
    }
  }

  fnIsRole(role: string) {
    return this.authService.isRole(role);
  }

}
